<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('/admin/partners')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Add Partners</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <b-form-group label="Description">
          <quill-editor
            v-model="description"
            :options="editorOption"
            class="quill-h200px my-2 z-50 relative"
          />
        </b-form-group>

        <FileUploader :image="image" :onSuccess="handleSuccess" />
        <img :src="image" alt="" v-if="image" />
        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <div class="py-4 customboxed">
          <p>Redirect Link ( Prefix this link with' https:// ' )</p>
          <base-input
            class="mb-3"
            name="Link"
            placeholder="Enter Redirection Link "
            v-model="link"
          >
          </base-input>
        </div>
        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";
import "vue-advanced-cropper/dist/style.css";
import { Cropper } from "vue-advanced-cropper";
// import Data from "../../../../../admin/pages/add-product/components/Data";

export default {
  components: {
    FileUploader,
    quillEditor,
    Cropper,
  },
  data() {
    return {
      // title: "",
      link: "",
      description: "",
      editorOption: {
        theme: "snow",
      },
      image: null,
      coverImage: null,
    };
  },
  methods: {
    handleSuccess(image) {
      console.log(image);

      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      } else if (!image.type.includes("image")) {
        this.$swal.fire({
          title: "File Type!",
          html: "<p style='text-align:center'>Please ensure that the file Type should be Image</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      } else {
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },

    async onSubmit() {
      let Regex = /^(|https?:\/\/([a-z0-9-]+\.)+[a-z0-9-]{2,6}(\/[^\s]*)?)$/i;
      if (this.link.trim() !== "" && !Regex.test(this.link.trim())) {
        this.$notify.error({
          message: "Please Enter Valid URL",
          position: "bottom-right",
        });
        return false;
      }
      if (!this.coverImage) {
        this.$notify.error({
          message: "Please Select Image",
          position: "top-right",
        });
        return;
      }
      let FormData = require("form-data");
      let data = new FormData();
      if (this.description.trim()) {
        data.append("description", this.description.trim());
      }
      // if (!this.description) {
      //   this.$notify.error({
      //     message: "Description is required  ",
      //     position: "top-right",
      //   });
      //   return;
      // }
      if (this.link.trim()) {
        data.append("link", this.link);
      }
      data.append("picture", this.coverImage);
      let loader = this.$loading();

      try {
        const newsdata = await this.$store.dispatch(
          "partners/createPartners",
          data
        );

        if (newsdata.code == 200) {
          this.$router.push({ name: "/admin/partners" });
          this.$swal.fire({
            text: "Partner Successfully Added",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        loader.close();
      } catch (error) {
        // if (error.response.status) {
        //   this.$swal.fire({
        //     title: "Error",

        //     text: error.response.data.message,
        //     confirmButtonText: "Okay",
        //     icon: "warning",
        //     confirmButtonColor: "#830c81",
        //     showCancelButton: false,
        //   });
        //   loader.close();
        // }
        if (error.response) {
          if (error.response.status === 401) {
            console.log("routing to sign in looopppp ");
            this.$router.push({ name: "signin" });
            this.$swal.fire({
              title: "Session Expired",
              text: "Your session has ended and for security reasons, we request you to login again",
              icon: "warning",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
          }
        }
        loader.close();
      }
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
